import ShopMiniBasketModelBase from '../_generated/modelBases/shop-mini-basket-model-base';

export default class ShopMiniBasketModel extends ShopMiniBasketModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
